/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Library = {

	delete (context, libraryId, onSuccess, onError, options) {
		Api.delete(context,
			"/library"
			+ "?libraryId=" + libraryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAll (context, onSuccess, onError, options) {
		Api.get(context,
			"/library/all"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getDownload (context, libraryId, onSuccess, onError, options) {
		Api.get(context,
			"/library/download"
			+ "?libraryId=" + libraryId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getMyRole (context, onSuccess, onError, options) {
		Api.get(context,
			"/library/my-role"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, file, libraryUserRoleType, onSuccess, onError, options) {
		Api.post(context,
			"/library"
			+ "?file=" + file
			+ "&libraryUserRoleType=" + libraryUserRoleType
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
